import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingProfileAction } from '../routingProfile.action';
import { RoutingProfileTranslator } from '../routingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const createRoutingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(RoutingProfileAction.create.started),
  switchMap(({ params, reject }) => {
    const apiPayload = RoutingProfileTranslator.toApi(params);

    return dependencies.api.createRoutingProfile(apiPayload).pipe(
      mergeMap((result) => {
        return [
          RoutingProfileAction.create.done({
            params,
            result: { routingProfileId: result.id },
          }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          RoutingProfileAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
